import { defaults } from "lodash-es"
import { useLocation } from "react-router-dom"

export function useLocationState<T extends object>(defaultObj: T): T {
    let state: unknown
    ({ state } = useLocation())

    return defaults(state, defaultObj)
}
